import { Row } from '@lightningjs/ui-components';

//Components
import Button from './components/Button';

//AuthRoute
import AuthRoute from '../../../components/layouts/AuthRoute/AuthRoute';
import Lightning from '@lightningjs/sdk/src/Lightning';
import { Utils } from '@lightningjs/sdk';

export default class EditProfiles extends AuthRoute {
  static _template() {
    return {
      ...super._template(),
      LogoIcon: {
        w: 606,
        h: 274,
        Shadow: {
          y: 806,
          x: 1314,
          rect: true,
          texture: Lightning.Tools.getSvgTexture(Utils.asset('images/logo-shadow.png'), 606, 274),
          zIndex: 99,
        },
        Logo: {
          y: 978,
          x: 1555,
          texture: Lightning.Tools.getSvgTexture(Utils.asset('images/logo.png'), 341, 53),
          zIndex: 100,
        },
      },
      Wrapper: {
        w: 1920,
        h: 1080,
        Title: {
          y: 200,
          w: 1920,
          text: {
            textAlign: 'center',
            text: 'Edit Profiles',
            fontSize: 53,
          },
        },
        Profiles: {
          collision: true,
          y: 350,
          h: 240,
          w: 1920,
          flex: {
            direction: 'row',
            justifyContent: 'center',
          },
          type: Row,
          style: {
            itemSpacing: 50,
          },
          plinko: true,
        },
      },
      Button: {
        collision: true,
        type: Button,
      },
    };
  }

  get id() {
    return 'EditProfilePage';
  }

  get _Profiles() {
    return this.tag('Wrapper.Profiles');
  }

  _firstActive() {
    this._setState('Profiles');
  }

  $setState(state) {
    this._setState(state);
  }

  $setIndex(index) {
    this._Profiles.selectedIndex = index;
  }

  static _states() {
    return [
      class Profiles extends this {
        _getFocused() {
          return this._Profiles;
        }

        _handleDown() {
          this._setState('Button');
        }

        _captureEnter() {
          let fp = this.application.focusPath;
          let activeTile = fp[fp.length - 1].data || {};

          if (activeTile.id !== 0) {
            this.navigate(`profile/edit-profile/${activeTile.id}`);
          } else {
            this.navigate(`profile/create-profile`);
          }
        }
      },

      class Button extends this {
        _getFocused() {
          return this.tag('Button');
        }
        _handleUp() {
          this._setState('Profiles');
        }

        _handleClick() {
          this._handleEnter();
        }

        _handleEnter() {
          this.navigate('#profile');
        }
      },
    ];
  }
}
